import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "condensed", "flush", "hover", "maxHeight", "ScrollContainer"];
import styled from 'styled-components';
import { Table } from './Table';
import devLogger from 'react-utils/devLogger';
import { ScrollContainer as ScrollContainerComponent } from '../ScrollContainer';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { isIE11 } from '../../utils/BrowserTest';
import { useTheme } from 'foundations-theming/utils';
import { useTableStyles } from './Table.styles';
import { TableContext } from './TableContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledContainer = styled.div.withConfig({
  displayName: "StickyHeaderTable__StyledContainer",
  componentId: "sc-1ho4kcn-0"
})(({
  theme,
  $cssStyles
}) => {
  return Object.assign({
    border: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`
  }, $cssStyles);
});
export const StickyHeaderTable = props => {
  const {
      children,
      condensed = false,
      flush = true,
      hover = true,
      maxHeight,
      ScrollContainer = ScrollContainerComponent
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps,
    restProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const theme = useTheme();
  const {
    tableHeaderHeight
  } = useTableStyles();
  const tableVariantStyleOverrides = {
    borderWidth: theme.space['0'],
    '& thead': Object.assign({
      display: 'flex',
      position: isIE11() ? 'absolute' : 'sticky',
      top: theme.space['0'],
      backgroundColor: theme.color['fill-surface-default'],
      // Because <th> cells have a partially transparent background
      zIndex: 1
    }, !isIE11() && {
      borderBottom: `${theme.space['25']} solid ${theme.color['border-core-subtle']}`
    }),
    '& thead th': {
      borderTopWidth: theme.space['0']
    },
    '& tbody': Object.assign({
      display: 'table'
    }, isIE11() && {
      transform: `translateY(${tableHeaderHeight})`
    }),
    '& tbody tr:first-child td': Object.assign({}, !isIE11() && {
      borderTopWidth: theme.space['0']
    })
  };
  if (process.env.NODE_ENV !== 'production') {
    if (typeof maxHeight === 'string' && maxHeight.includes('%')) {
      devLogger.warn({
        message: 'StickyHeaderTable: `maxHeight` must be a fixed value, not a % value.',
        key: 'sticky-maxheight'
      });
    }
  }
  return /*#__PURE__*/_jsx(StyledContainer, Object.assign({}, domProps, callbackProps, restProps, {
    $cssStyles: cssStyles,
    children: /*#__PURE__*/_jsx(ScrollContainer, {
      maxHeight: maxHeight,
      scrollDirection: "both",
      children: /*#__PURE__*/_jsx(TableContext.Provider, {
        value: {
          bordered: true,
          condensed,
          _exteriorBorders: true,
          tableVariantStyleOverrides
        },
        children: /*#__PURE__*/_jsx(Table, {
          condensed: condensed,
          flush: flush,
          responsive: false,
          hover: hover,
          children: children
        })
      })
    })
  }));
};